export default __webpack_public_path__ + "static/media/results-nutrition.0eff8f33.jpg";